<template>
  <div class="error-modal">
    <div class="error-box">
      <span class="close-icon" @click="$emit('close')">×</span>
      <h2>⚠️ {{ title }} ⚠️</h2>
      <p>{{ message }}</p>
      <img
        src="@/assets/images/server-error.jpg"
        alt="Server Error"
        class="responsive-image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroError",
  props: {
    title: {
      type: String,
      default: "Server Error",
    },
    message: {
      type: String,
      default: "Something went wrong. Please try again later.",
    },
  },
};
</script>

<style scoped>
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-box {
  position: relative;
  background: white;
  padding: 24px;
  border-radius: 10px;
  max-width: 60%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
}

.close-icon {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s ease;
}
.close-icon:hover {
  color: #cc0000;
}

.error-box h2 {
  font-size: 40px;
  color: #4c5c80;
}

.responsive-image {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: contain;
  display: block;
  margin: 1rem auto;
}
</style>
